import React from "react";
import AddRoundedIcon from "@mui/icons-material/Add";

import { getNumberFormat } from "../../../../utils";
import Button, { ButtonTypes } from "../../../../components/Button";
import {
  HeroStrip,
  HeroSection,
  HeroPrimarySection,
  HeroRightColumn,
  HeroActions,
  HeroActionsDivider,
  HeroDivider,
  HeroSubRow,
  HeroInnerDivider,
  HeroLabel,
  HeroValue,
  HeroSubtitle,
} from "./styles";
import { AccountsStatsProps } from "./types";

export const AccountsStats: React.FC<AccountsStatsProps> = ({
  currentAmount,
  inAmount,
  outAmount,
  accountCount,
  selectedFilter,
  onCreateAccount,
  showCreateButton,
}) => {
  const accountLabel =
    accountCount === 1 ? "1 account" : `${accountCount} accounts`;
  const isNegativeBalance = currentAmount < 0;
  const currentTone = isNegativeBalance ? "negative" : "positive";

  return (
    <HeroStrip role="region" aria-label="Account statistics">
      <HeroPrimarySection>
        <HeroLabel>Current Value</HeroLabel>
        <HeroValue
          $tone={currentTone}
          aria-label={`Current value: ${getNumberFormat(currentAmount)} euros`}
        >
          {getNumberFormat(currentAmount)} €
        </HeroValue>
        <HeroSubtitle>
          Across {accountLabel} · {selectedFilter}
        </HeroSubtitle>
      </HeroPrimarySection>

      <HeroDivider aria-hidden="true" />

      <HeroRightColumn>
        {showCreateButton && (
          <>
            <HeroActions>
              <Button
                size="medium"
                type={ButtonTypes.primary}
                onClick={onCreateAccount}
              >
                <AddRoundedIcon fontSize="small" />
                Create Account
              </Button>
            </HeroActions>
            <HeroActionsDivider aria-hidden="true" />
          </>
        )}

        <HeroSubRow>
          <HeroSection>
            <HeroLabel>Deposited</HeroLabel>
            <HeroValue
              $tone="positive"
              aria-label={`Total deposited: ${getNumberFormat(inAmount)} euros`}
            >
              {getNumberFormat(inAmount)} €
            </HeroValue>
            <HeroSubtitle>{selectedFilter}</HeroSubtitle>
          </HeroSection>

          <HeroInnerDivider aria-hidden="true" />

          <HeroSection>
            <HeroLabel>Withdrawn</HeroLabel>
            <HeroValue
              $tone="negative"
              aria-label={`Total withdrawn: ${getNumberFormat(outAmount)} euros`}
            >
              {getNumberFormat(outAmount)} €
            </HeroValue>
            <HeroSubtitle>{selectedFilter}</HeroSubtitle>
          </HeroSection>
        </HeroSubRow>
      </HeroRightColumn>
    </HeroStrip>
  );
};
